import request from '@/utils/request'

// 行业动态列表(首页无权限)
export function industryNoAuthList(query) {
    return request({
        url: '/aromatics/industry/noAuth/boardList',
        method: 'get',
        params: query
    })
}

// 行业动态列表
export function industryList(query) {
    return request({
        url: '/aromatics/industry/pyrobenzeneList',
        method: 'get',
        params: query
    })
}

// 行业动态详情
export function industryDetail(id) {
    return request({
        url: `/aromatics/industry/getPyrobenzeneInfo/${id}`,
        method: 'get',
    })
}

// 研究报告列表(首页无权限)
export function reportNoAuthList(query) {
    return request({
        url: '/aromatics/report/noAuth/list',
        method: 'get',
        params: query
    })
}

// 研究报告列表
export function reportList(query) {
    return request({
        url: '/aromatics/report/reportPyrobenzeneList',
        method: 'get',
        params: query
    })
}

// 技术及标准列表
export function standardList(query) {
    return request({
        url: '/aromatics/report/technicalPyrobenzeneList',
        method: 'get',
        params: query
    })
}

// 研究报告详情
export function reportDetail(id) {
    return request({
        url: `/aromatics/report/boardPyrobenzeneInfo/${id}`,
        method: 'get',
    })
}

// 技术及标准详情
export function standardDetail(id) {
    return request({
        url: `/aromatics/report/technicalPyrobenzeneInfo/${id}`,
        method: 'get',
    })
}


// 产量列表（无权限）
export function yieldNoAuthList(query) {
    return request({
        url: '/aromatics/yield/noAuth/list',
        method: 'get',
        params: query
    })
}

// 产量列表
export function yieldList(query) {
    return request({
        url: '/aromatics/druidEnter/pyrobenzeneYieldList',
        method: 'get',
        params: query
    })
}

// 产量详情
export function yieldDetail(query) {
    return request({
        url: `/aromatics/druidEnter/getPyrobenzeneYieldInfo`,
        method: 'get',
        params: query
    })
}

// 相关产品列表（无权限）其他
export function productPricedNoAuthList(query) {
    return request({
        url: '/aromatics/metatron/price/noAuth/petroleumPlaceList',
        method: 'get',
        params: query
    })
}

// 相关产品列表其他
export function productPricedList(query) {
    return request({
        url: '/aromatics/metatron/price/detailsPyrobenzenePriceList',
        method: 'get',
        params: query
    })
}

// 相关产品详情其他
export function productPriceDetail(query) {
    return request({
        url: `/aromatics/metatron/price/detailsPyrobenzenePrice`,
        method: 'get',
        params: query
    })
}

// 相关产品列表苯乙烯
export function productPricedListBen(query) {
    return request({
        url: '/aromatics/industry/pyrobenzeneStyreneList',
        method: 'get',
        params: query
    })
}

// 相关产品详情苯乙烯
export function productPriceDetailBen(id) {
    return request({
        url: `/aromatics/industry/getPyrobenzeneStyreneInfo/${id}`,
        method: 'get',
    })
}

// 价格列表（无权限）
export function priceNoAuthList(query) {
    return request({
        url: '/aromatics/druidEnter/noAuth/queryPage',
        method: 'get',
        params: query
    })
}

// 价格列表
export function priceList(query) {
    return request({
        url: '/aromatics/druidEnter/petroleumListPrice',
        method: 'get',
        params: query
    })
}

// 价格详情
export function priceDetail(query) {
    return request({
        url: `/aromatics/druidEnter/getPetroleumListPriceInfo`,
        method: 'get',
        params: query
    })
}

// 进出口列表
export function exitGuoList(query) {
    return request({
        url: '/aromatics/industry/pyrobenzeneSaleStatisticsList',
        method: 'get',
        params: query
    })
}

// 进出口详情
export function exitGuoDetail(id) {
    return request({
        url: `/aromatics/industry/getPyrobenzeneSaleStatisticsInfo/${id}`,
        method: 'get',
    })
}

// 装置动态列表
export function deviceList(query) {
    return request({
        url: '/aromatics/industry/pyrobenzeneDeviceDynamicList',
        method: 'get',
        params: query
    })
}

// 装置动态详情
export function deviceDetail(id) {
    return request({
        url: `/aromatics/industry/getPyrobenzeneDeviceDynamicInfo/${id}`,
        method: 'get',
    })
}

// 库存列表
export function stockList(query) {
    return request({
        url: '/aromatics/industry/pyrobenzeneStockList',
        method: 'get',
        params: query
    })
}

// 库存详情
export function stockDetail(id) {
    return request({
        url: `/aromatics/industry/getPyrobenzeneStockInfo/${id}`,
        method: 'get',
    })
}

// 后两个价格列表（第一个）
export function backPriceList(query) {
    return request({
        url: '/aromatics/industry/marketPriceList',
        method: 'get',
        params: query
    })
}

// 后两个价格列表（第二个）
export function backTwoPriceList(query) {
    return request({
        url: '/aromatics/industry/benzenePriceList',
        method: 'get',
        params: query
    })
}

// 后两个价格详情(第一个)
export function backPriceDetail(id) {
    return request({
        url: `/aromatics/industry/getMarketPriceInfo/${id}`,
        method: 'get',
    })
}

// 后两个价格详情(第二个)
export function backPriceTwoDetail(id) {
    return request({
        url: `/aromatics/industry/getHydrogenatedBenzeneInfo/${id}`,
        method: 'get',
    })
}

// 价格详情折线图
export function priceLineDetailData(query) {
    return request({
        url: '/aromatics/price/lineChart',
        method: 'get',
        params: query
    })
}

// 库存详情折线图
export function stockDetailData(query) {
    return request({
        url: '/aromatics/metatron/detail/lineChart',
        method: 'get',
        params: query
    })
}

// 价格详情三年折线图
export function priceDetailData(query) {
    return request({
        url: '/aromatics/metatron/detail/lineChart',
        method: 'get',
        params:query
    })
}

// 进出口详情柱状图
export function exitDetailData(query) {
    return request({
        url: '/aromatics/metatron/detail/exitDataTotalHistogram',
        method: 'get',
        params: query
    })
}

// 价格首页折线图
export function priceLineData(query) {
    return request({
        url: '/aromatics/metatron/detail/noAuth/serviceLineChart',
        method: 'get',
        params: query
    })
}

// 价格首页折线图大图
export function priceLineDataBig(query) {
    return request({
        url: '/aromatics/metatron/detail/cokePriceLineChart',
        method: 'get',
        params: query
    })
}

// 开工率首页折线图
export function rateLineData(query) {
    return request({
        url: '/aromatics/rate/noAuth/lineChart',
        method: 'get',
        params: query
    })
}

// 开工率折线图大图
export function rateLineDataBig(query) {
    return request({
        url: '/aromatics/metatron/detail/pyrobenzeneOpenRateLineChart',
        method: 'get',
        params: query
    })
}

// 华东市场价格详情折线图
export function priceDetailDataHua(query) {
    return request({
        url: '/aromatics/metatron/detail/lineChartOneYear',
        method: 'get',
        params: query
    })
}

// 产业链
export function chainList(query) {
    return request({
        url: '/aromatics/metatron/chain/noAuth/chainPrice',
        method: 'get',
        params: query
    })
}

// 化工产品外链权限
export function getAuthFlag() {
    return request({
        url: '/aromatics/price/getAuthFlag',
        method: 'get',
    })
}
